export const GC_ONE_PAGE_CHECKOUT_GROUP = "gc-one-page-checkout-group";
export const GC_ONE_PAGE_CHECKOUT_LOGIN_GROUP = "gc-one-page-checkout-login-group";

export default Object.assign(
  {
    "dummy-feature": [0], // for unit tests and manually testing production integration
  },
  {
    // 'feature name': [Array of index to bits in hash],
    [GC_ONE_PAGE_CHECKOUT_GROUP]: [1],
    [GC_ONE_PAGE_CHECKOUT_LOGIN_GROUP]: [2, 3, 4],
  }
);

export const isTestGroupFeatureEnabled = (testGroupFeature) => {
  return Boolean(document.querySelector(`.feature-${testGroupFeature}`));
};
